import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./TeamCarousel.css";

const teamCarousel = [
  {
    image: require("../../assets/Client_images/01.jpg"),
  },
  {
    image: require("../../assets/Client_images/02.jpg"),
  },
  {
    image: require("../../assets/Client_images/03.jpg"),
  },
  {
    image: require("../../assets/Client_images/04.jpg"),
  },
  {
    image: require("../../assets/Client_images/05.jpg"),
  },
];

export const TeamCarousel = () => {
  return (
    <section className="team-carousel">
      <div className="team-heading">
        <h2>Meet Partners</h2>
        <p>
  We’ve built strong relationships with industry-leading partners from around the globe — experts who are shaping the future with innovation, experience, and excellence.
</p>
      </div>

      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        centeredSlides={true}
        slidesPerView={3}
        spaceBetween={0}
        breakpoints={{
          320: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="swiper-container team-swiper"
      >
        {teamCarousel.map((member, idx) => (
          <SwiperSlide key={idx}>
            <div className="team-card">
              <img src={member.image} alt={member.name} />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

